import Swiper from 'swiper/bundle'

export default () => {
    if (document.querySelector('.swiper-testimonials')) {
        const testimonialsSlider = new Swiper('.swiper-testimonials', {
            slidesPerView: 1,
            centeredSlides: true,
            centeredSlidesBounds: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        })
    }

    if (document.querySelector('.swiper-gallery')) {
        const gallerySlider = new Swiper('.swiper-gallery', {
            slidesPerView: 1.4,
            spaceBetween: 10,
            grabCursor: true,
            breakpoints: {
                640: {
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 2.2,
                },
                2600: {
                    slidesPerView: 3.2,
                },
            },
        })
    }
}
